import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import sumBy from 'lodash/sumBy';

export const roomMeasureSelector = createSelector(
  (state) => state.measures,
  (measure) => measure
);

export const openOverlaySelector = createSelector(
  (state) => state.measures,
  (isOpenOverlay) => isOpenOverlay,
);

export const roomsArraySelector = createSelector(
  roomMeasureSelector,
  (measures) => measures.measure
);

export const roomMeasureCountSelector = createSelector(
  [roomMeasureSelector, (state) => state.steps],
  (rooms, steps) => rooms.measure.length + (steps?.stairsSquareFeet > 0 ? 1 : 0)
);

export const totalRoomMeasureAreaSelector = createSelector(
  [roomMeasureSelector, (state) => state.steps],
  (rooms, steps) => sumBy(rooms.measure, 'sqFt') + steps.stairsSquareFeet
);

export const roomMeasuresWithStairs = createSelector(
  [(state) => state.measures, (state) => state.steps],
  ({ measure }, stepsState) => {
    const {
      stepsId: id,
      length,
      width,
      stairsSquareFeet: sqFt,
      price,
      stairsSquarePrice: squarePrice,
      totalPrice,
      padPrice,
      steps
    } = stepsState;
    if (steps !== '' && sqFt > 0) {
      return [...measure, {
        id,
        room: 'Stairs',
        length,
        width,
        sqFt,
        price,
        squarePrice,
        totalPrice,
        padPrice,
      }];
    }
    return measure;
  }
);

export const hasSavedRoomSelector = createSelector(
  roomsArraySelector,
  (rooms) => !isEmpty(rooms)
);

export const selectedRow = createSelector(
  (state) => state.measures,
  (currentRow) => currentRow.currentEditedRow,
  (currentEditedRow) => currentEditedRow,
);

export const currentRow = (rooms) => {
  const { measure, currentEditedRow } = rooms;
  return measure.filter((room) => room.id === currentEditedRow);
};

export const currentRowSelector = createSelector(
  roomMeasureSelector,
  selectedRow,
  (allRooms, Id) => currentRow(allRooms, Id),
);